<template>
  <div id="tab-bar">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabBar",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>
#tab-bar {
  display: flex;
  // background: #f5f5f5;
  width: 100%;
}
</style>